import { Link } from "react-router-dom";

interface PageBannerProps {
  eyebrow: string;
  title: string;
  highlight: string;
  subtitle: string;
  image: string;
  imageAlt: string;
  ctaLabel?: string;
  ctaTo?: string;
}

export default function PageBanner({
  eyebrow,
  title,
  highlight,
  subtitle,
  image,
  imageAlt,
  ctaLabel,
  ctaTo,
}: PageBannerProps) {
  return (
    <section className="relative w-full pt-28 md:pt-36 pb-14 md:pb-20 overflow-hidden">
      <img
        src={image}
        alt={imageAlt}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-8 max-w-6xl mx-auto text-center">
        <nav className="flex items-center justify-center gap-2 text-xs text-background-100/80">
          <Link to="/" className="hover:text-accent-300 transition-colors">Home</Link>
          <i className="ri-arrow-right-s-line text-accent-400"></i>
          <span className="text-accent-300 font-medium">{eyebrow}</span>
        </nav>

        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-xs md:text-sm font-medium tracking-wide px-4 py-1.5 mt-5">
          <i className="ri-vip-diamond-line text-accent-400"></i>
          {eyebrow}
        </span>

        <h1 className="font-heading text-3xl md:text-5xl text-background-50 mt-4 leading-tight">
          {title} <span className="italic text-accent-300">{highlight}</span>
        </h1>

        <p className="max-w-2xl mx-auto text-background-100/90 text-sm md:text-base mt-4 leading-relaxed">
          {subtitle}
        </p>

        {ctaLabel && ctaTo && (
          <Link
            to={ctaTo}
            className="inline-flex items-center justify-center gap-2 mt-7 text-sm md:text-base font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-7 md:px-9 py-3.5 hover:bg-accent-600 transition-colors"
          >
            {ctaLabel}
            <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>
    </section>
  );
}